import type { ValueOf } from 'type-fest';

import type {
  AccountFilterValue,
  ContactFilterValue,
  SalespersonFilterValue,
  EstimatorFilterValue,
  RelationFilterValue,
} from 'components/listTablePage';
import type { TransformedRelationFilterValue } from 'components/listTablePage';

export type OrdersListFiltersValues = {
  processIn?: number[];
  totalPrice?: string;
  paymentStatus?: PaymentStatus;
  orderedDate?: TransformedRelationFilterValue;
} & AccountFilterValue &
  ContactFilterValue &
  SalespersonFilterValue &
  EstimatorFilterValue;

export type OrdersListFiltersFormData = {
  processIn?: number[];
  totalPrice?: string;
  paymentStatus?: PaymentStatus;
  orderedDate?: RelationFilterValue;
} & AccountFilterValue &
  ContactFilterValue &
  SalespersonFilterValue &
  EstimatorFilterValue;

export const PAYMENT_STATUSES = {
  ALL: '',
  CREDIT_CARD: 'credit_card',
  PO: 'po',
} as const;

export type PaymentStatus = ValueOf<typeof PAYMENT_STATUSES>;
